import { render, staticRenderFns } from "./TermModal.vue?vue&type=template&id=5dc37d20&"
import script from "./TermModal.vue?vue&type=script&lang=js&"
export * from "./TermModal.vue?vue&type=script&lang=js&"
import style0 from "./TermModal.vue?vue&type=style&index=0&id=5dc37d20&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports